import React, { useState, useEffect } from "react";

const UserProfileFlip = ({ frontImageUrl, backImageUrl }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsFlipped(true), 1800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative w-64 h-64 sm:w-72 sm:h-72" style={{ perspective: "1000px" }}>
      <div
        className="w-full h-full"
        style={{
          transformStyle: "preserve-3d",
          transform: `rotateY(${isFlipped ? "180deg" : "0deg"})`,
          transition: "transform 0.9s ease",
        }}
      >
        {/* Front face */}
        <div
          className="absolute w-full h-full rounded-full overflow-hidden ring-4 ring-emerald-500/20 shadow-2xl shadow-emerald-500/10"
          style={{ backfaceVisibility: "hidden" }}
        >
          <img src={frontImageUrl} alt="Avatar" className="w-full h-full object-cover" />
        </div>
        {/* Back face */}
        <div
          className="absolute w-full h-full rounded-full overflow-hidden ring-4 ring-emerald-500/20 shadow-2xl shadow-emerald-500/10"
          style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}
        >
          <img src={backImageUrl} alt="Profile" className="w-full h-full object-cover" />
        </div>
      </div>
    </div>
  );
};

export default UserProfileFlip;
